import styled from 'foundations-theming/utils';
export const VisibilityView = styled.div.withConfig({
  displayName: "VisibilityView",
  componentId: "mr3z5b-0"
})(({
  visible = true
}) => {
  return {
    visibility: visible ? 'visible' : 'hidden',
    width: '100%'
  };
});